// extracted by mini-css-extract-plugin
export default {"map":"VIP18tmDXrnr6agYe3OI"};